import React from "react";
import ReactDOM from "react-dom";
import "./app/layout/styles.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history"; // manually had to write and its part of Router lib
//import { configureStore } from "./app/store/configureStore";
import { Provider } from "react-redux";
import { store } from "./app/store/configureStore";

//for home page carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//const store = configureStore();
export const history = createBrowserHistory();

/*ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);*/

// inorder to use history, had to change BrowserRouter to Router.

// To disable the console.log on production
if (process.env.NODE_ENV !== "development") {
  console.log("Its a production version. All logs disabled");
  console.log = () => {};
}

ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
      <Provider store={store}>
        {/* the APP component used here is coming from layout folder */}
        <App />
      </Provider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
